import marketingManagement from "../../assets/Landing Page/marketing_management.png";
import socialMedia from "../../assets/Landing Page/social_media_marketing.png";
import copyWriting from "../../assets/Landing Page/copywriting.jpg";
import facebookAds from "../../assets/Landing Page/facebook_ads.png";
import youtubeAds from "../../assets/Landing Page/youtube-ads.jpg";
import influencerMarketing from "../../assets/Landing Page/influencer-marketing.jpg";
import seo from "../../assets/Landing Page/SEO.jpg";

export const thumbnail = [
  marketingManagement,
  socialMedia,
  copyWriting,
  facebookAds,
  youtubeAds,
  influencerMarketing,
  seo,
];
